import { Link } from "react-router-dom";

export default function MainMenu() {
    return (
        <>
            {/* <div className="column">
                <Link to="/Contribution/1"><button disabled={true}>ENTER CONTRIBUTION</button></Link>
                <button disabled={true}>PREVIEW ALL THANK YOU LETTERS</button>
                <button disabled={true}>PRINT ALL THANK YOU LETTERS</button>
                <button disabled={true}>PREVIEW ALL RECEIPTS</button>
                <button disabled={true}>PRINT LABELS FOR ALL MEMEBERS</button>
            </div> */}

            <div className="column">
                <Link to="/PrintTaxReceipt"><button>PRINT ALL RECEIPTS</button></Link>
                {/* <button disabled={true}>PRINT LABELS FOR TAX RECEIPT</button> */}
                <Link to="/CommunityList"><button>SORT/SEARCH CHI HỘI</button></Link>
                <Link to="/ReportLanding"><button>REPORTS</button></Link>
                {/* <Link to="/ReportYearlyContribution"><button disabled={false}>TOTAL DONATIONS (ENTER YEAR)</button></Link>
                <Link to="ReportYearlyAll"><button disabled={false}>ALL DATA WITH TOTAL (ENTER YEAR)</button></Link> */}
            </div>
        </>
    );
}